


















import { PartnerPracticeAddress } from '@/shared/partner-practice-address';
import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class PartnerPracticeAddressList extends Vue {
    @Prop({ required: true }) private addresses!: Array<PartnerPracticeAddress>;

    private onAddAddress(): void {
        this.$emit('add');
    }
}
